<script setup>
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import returnSaleImage from 'dashboard/assets/real-estate/sales-review/devolver-venda.svg';

defineProps({
  saving: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
</script>

<template>
  <LaisModal
    :show="show"
    max-width-class="max-w-[1046px]"
    @close="emit('close')"
  >
    <div
      class="grid gap-6 p-2 sm:grid-cols-[minmax(190px,250px)_1fr] sm:items-center sm:gap-10"
    >
      <img
        :src="returnSaleImage"
        :alt="t('SALES.REVIEW.RESUBMIT_CONFIRMATION.ALT')"
        class="mx-auto max-h-72 w-full max-w-[250px] object-contain sm:max-h-[360px] sm:max-w-none"
      />
      <div class="grid gap-6">
        <h2
          class="font-redHatDisplay text-2xl font-bold leading-tight text-lais-text sm:text-[32px]"
        >
          {{ t('SALES.REVIEW.RESUBMIT_CONFIRMATION.TITLE') }}
        </h2>
        <p class="text-sm leading-[22px] text-lais-text-body sm:text-base">
          {{ t('SALES.REVIEW.RESUBMIT_CONFIRMATION.DESCRIPTION') }}
        </p>
        <p
          class="text-sm font-bold leading-[22px] text-lais-text-body sm:text-base"
        >
          {{ t('SALES.REVIEW.RESUBMIT_CONFIRMATION.ATTENTION') }}
        </p>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-end">
        <LaisPrimaryButton
          size="lg"
          icon="i-lucide-check"
          :is-loading="saving"
          :disabled="saving"
          @click="emit('confirm')"
        >
          {{ t('SALES.REVIEW.RESUBMIT_CONFIRMATION.ACTION') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
